import { Dispatch, SetStateAction, useState } from 'react'
import './Rating.scss'
import starFilled from 'assets/icons/star-filled.svg'
import starEmpty from 'assets/icons/star-empty.svg'

interface RatingProps {
  readOnly?: boolean
  value: number
  id?: number
  setValue?: (id: number, rating: number) => void
  stars?: number
}

export default function StarRating({ readOnly = false, stars = 5, value, id, setValue }: RatingProps) {
  const [rating, setRating] = useState(value)
  const [hover, setHover] = useState(0)

  const handleMouseEnter = (index: number) => () => {
    if (readOnly) return
    setHover(index)
  }
  const handleMouseLeave = (rating: number) => () => {
    if (readOnly) return
    setHover(rating)
  }

  const handleSetRating = (ind: number) => {
    setRating(ind)
    setValue?.(id!, ind)
  }

  // const classes = (index: number) => {
  //   if (readOnly) return index <= (hover || value) ? 'rating_on' : 'rating_off'
  //   return index <= (hover || rating) ? 'rating_on' : 'rating_off'
  // }

  const chooseStar = (index: number) => {
    if (readOnly) return index <= (hover || value) ? starFilled : starEmpty
    return index <= (hover || rating) ? starFilled : starEmpty
  }

  return (
    <div className="star_rating_comp">
      {[...Array(stars)]?.map((_, index) => {
        let ind = index + 1
        return (
          <button
            id="rating_btn"
            type="button"
            key={ind}
            // className={classes(ind)}
            onClick={() => handleSetRating(ind)}
            onMouseEnter={handleMouseEnter(ind)}
            onMouseLeave={handleMouseLeave(rating)}>
            {/* <span className="rating_star">&#9733;</span> */}
            <img alt="star-icon" className="rating_star" width={20} height={30} src={chooseStar(ind)} />
          </button>
        )
      })}
    </div>
  )
}
